<template>
  <Layout :show-links="false">
    <Jumbotron :authorizationLink="{}" errorPage :title="$t('generating')" />
    <Cards />
    <JumbotronSmall :authorizationLink="{}" errorPage />
  </Layout>
</template>

<script>
import { localizedLink, orgConfig } from "@/mixins";
import Jumbotron from "@/components/homepage/Jumbotron";
import JumbotronSmall from "@/components/homepage/JumbotronSmall";
import Cards from "@/components/homepage/Cards";

export default {
  mixins: [localizedLink, orgConfig],
  components: {
    Jumbotron,
    JumbotronSmall,
    Cards
  }
};
</script>
